import type { UserRef } from '@cyphex/types';
import { useViewer } from './useShellData';

/**
 * The signed-in user as a `UserRef` — the shape every "is this mine?" check and
 * every optimistic reaction needs.
 *
 * It reads the same cached `/me` entry the shell already fetched, so it costs
 * no extra request, and it is the reason no component has to import a fixture
 * to know who it is rendering for.
 */
export function useViewerRef(): UserRef | null {
  return useViewer().data ?? null;
}
